import React, { Component } from 'react';
import { readAsDataURL } from 'promise-file-reader';
import URLSearchParams from 'url-search-params';

import SocialServices, { DOWNLOAD_SERVICE, FACEBOOK_SERVICE, TWITTER_SERVICE } from '../utils/socialServices';

import Header from './header';
import Footer from './footer';
import Preloader from '../utils/preloader';
import MemeCanvas, { ImageDescriptor } from './memeCanvas';

import { httpClient, store, asyncActionCreators, memeActionCreators } from './model/store';

//import { Route, Switch } from 'react-router-dom';

// Network utils:
import { base64ImagesForURLs } from '../utils/http';

const isMobile = () => {
	return window.Modernizr.mobile;
};

const fieldIdFromIndex = index => {
	return `textInput-${index}`;
};

const MAX_FILE_SIZE_MB = 3;

class Main extends Component {
	constructor() {
		super();

		this.shareWindow = null;
		this.socialServices = new SocialServices({
			onSetProgress: b => {
				console.info(`Main.socialServices.onSetProgress(${b});`);
				store.dispatch(asyncActionCreators.createSetProgressAction(b));
			},
			httpClient: httpClient,
			config: store.getState().config.social,
		});

		base64ImagesForURLs([
			store.getState().config.meme.images.default,
			store.getState().config.meme.images.overlay,
		]).then(
			images => {
				store.dispatch(
					memeActionCreators.createSetConfigAction(
						{
							default: images[0],
							overlay: images[1],
						},
						store.getState().config.meme.fields
					)
				);
				setTimeout(() => {
					store.dispatch(asyncActionCreators.createSetProgressAction(false));
				}, 100);
			},
			error => {
				console.error('(***) Meme images error:', error);
			}
		);

		store.dispatch(asyncActionCreators.createSetProgressAction(true));
	}

	get params() {
		return this.props.match.params;
	}

	get currentStation() {
		return store.getState().config.stations[this.params.station || '*'];
	}

	get bucketName() {
		//return `${this.params.station || 'default'}${store.getState().config.bucketNamePostfix}`;
		return `birmingham${store.getState().config.bucketNamePostfix}`;
	}

	componentWillMount() {
		const self = this;
		this.unsubscribe = store.subscribe(() => {
			self.forceUpdate();
		});
	}

	componentWillUnmount() {
		this.unsubscribe();
		if (this.socialServices) {
			this.socialServices.destroy();
			this.socialServices = null;
		}
	}

	componentDidUpdate() {
		const firstField = fieldIdFromIndex(0);
		if (this.refs[firstField] && this.refs[firstField].value.length === 0) {
			this.refs[firstField].focus();
		}
	}

	rotateUserImage() {
		const { meme } = store.getState();
		const rotationAngle = (meme.rotation + 90) % 360;
		store.dispatch(memeActionCreators.createSetUserImageRotationAction(rotationAngle));
	}

	updateText(fieldIndex) {
		const input = this.refs[fieldIdFromIndex(fieldIndex)];
		if (input) {
			store.dispatch(memeActionCreators.createSetTextAction(fieldIndex, input.value));
		}
	}

	clearFileInput() {
		const input = this.refs.fileInput;
		if (input) {
			input.value = null;
			this.onFileInputChange();
		}
	}

	onFileInputChange() {
		const input = this.refs.fileInput;

		if (input.files.length > 0) {
			input.blur();
			const fileRef = input.files[0];
			const fileSizeInMb = Math.round((fileRef.size || 0) / 1024 / 1024);

			if (fileSizeInMb > MAX_FILE_SIZE_MB) {
				window.alert('File exceeds ' + MAX_FILE_SIZE_MB + 'Mb limit. Please choose a smaller file.');
				input.value = null;
				return;
			}

			store.dispatch(asyncActionCreators.createSetProgressAction(true));

			readAsDataURL(fileRef)
				.then(imageSrc => {
					const userImage = new Image();
					userImage.src = imageSrc;
					var processImage = function() {
						setTimeout(function() {
							if (userImage.width > 0) {
								setTimeout(() => {
									store.dispatch(asyncActionCreators.createSetProgressAction(false));
									store.dispatch(memeActionCreators.createSetUserImageAction(userImage));
								}, 100);
							} else {
								processImage();
							}
						}, 10);
					};
					processImage();
				})
				.catch(error => {
					window.alert('Error loading image: ' + error.message);
				});
		} else {
			store.dispatch(memeActionCreators.createSetUserImageAction(undefined));
		}
	}

	socialClick(event) {
		const { meme } = store.getState();
		const { text } = meme;
		switch (event.target) {
			case this.refs.facebookBtn: {
				const image = this.refs.memeCanvas.getCanvasImage();
				this.socialServices.socialClick({ message: text, service: FACEBOOK_SERVICE, image: image });
				break;
			}
			case this.refs.twitterBtn:
				this.socialServices.socialClick({ message: text, service: TWITTER_SERVICE });
				break;
			case this.refs.downloadBtn:
				this.socialServices.socialClick({ service: DOWNLOAD_SERVICE });
				break;
			default:
				break;
		}
	}

	moveUserImage(direction) {
		const { meme } = store.getState();
		const { offset } = meme;

		switch (direction) {
			case 'left':
				store.dispatch(memeActionCreators.createSetOffsetAction(offset - 25));
				break;
			case 'right':
				store.dispatch(memeActionCreators.createSetOffsetAction(offset + 25));
				break;
		}
	}

	saveMeme() {
		console.group('Main.saveMeme()');
		console.info('\t-> meme:', this.refs.memeCanvas.getCanvasImage());
		console.groupEnd();
		// TODO: SET IMAGE AS SAVAED:

		store.dispatch(asyncActionCreators.createSetProgressAction(true));

		const folder = this.bucketName;
		const image = this.refs.memeCanvas.getCanvasImage();
		const searchParams = new URLSearchParams();

		searchParams.set('text', folder);
		searchParams.set('image', image);

		//store.dispatch(memeActionCreators.createSetSavedAction());

		// const self = this;
		// const { folder } = self.props.canvasConfiguration;
		// const image = self.refs.canvas.toDataURL('image/png');

		// // TODOL FIRE SAVE ACTION:
		// // self.setState( { loading: true } );

		fetch('https://apps.interactiveone.com/meme/upload', {
			method: 'POST', // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, cors, *same-origin
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			},
			body: searchParams,
		})
			.then(function(response) {
				console.group('Main.saveMeme().fetch.then()');
				console.info('\t-> response:', response);
				console.info('\t-> response.body:', response.body);
				console.groupEnd();
				return response.json();
			})
			.then(function(json) {
				if (json.status === 'success' && json.url) {
					setTimeout(() => {
						store.dispatch(asyncActionCreators.createSetProgressAction(false));
						setTimeout(() => {
							store.dispatch(memeActionCreators.createSetSavedAction(true));
						}, 250);
					}, 250);
				}
			})
			.catch(error => console.error('Error:', error));
	}

	render() {
		const { async, meme, config } = store.getState();

		window.meme = meme;

		console.group('Main.render()');
		console.info('\t-> meme:', meme);
		console.info('\t-> store.getState():', store.getState());
		console.info('\t-> this.currentStation:', this.currentStation);
		console.info('\t-> this.bucketName:', this.bucketName);
		console.info('\t-> store.getState().router:', store.getState().router);
		console.groupEnd();

		// let { pathname } = this.props.location;

		console.info('(***) Main.render(), this:', this);

		return (
			<div>
				<Header />
				<div class="container-fluid">
					<div>
						<h2 class="meme-title text-center">
							Show Your Alabama Pride!
							<br />
							Upload your photo and Rep Your Yard!
						</h2>
						<div class="row" style={{ position: 'relative' }}>
							{meme.images.default && meme.images.overlay && !async.inProgress ? (
								<MemeCanvas
									ref="memeCanvas"
									imageDescriptors={[
										meme.images.user
											? ImageDescriptor.create(meme.images.user, meme.rotation, true, true, true)
											: ImageDescriptor.create(meme.images.default, 0, true, false),
										ImageDescriptor.create(meme.images.overlay, 0, true, false),
									]}
									width={config.meme.width}
									height={config.meme.height}
									fields={meme.fields}
									offset={meme.offset}
								>
									<input
										ref="fileInput"
										type="file"
										class="meme-image-uploader"
										onChange={() => {
											this.onFileInputChange(this.refs.fileInput.files[0]);
										}}
									/>
									<div
										class="meme-controls-container"
										style={{
											width: config.meme.width,
											height: config.meme.height,
										}}
									>
										{!meme.images.user ? (
											<button
												class="meme-action-btn upload-btn btn"
												onClick={() => {
													this.refs.fileInput.click();
												}}
											>
												UPLOAD IMAGE
											</button>
										) : (
											<div>
												{meme.fields.map((field, index) => {
													const fieldId = fieldIdFromIndex(index);
													return (
														<input
															key={index}
															ref={fieldId}
															id={field.id}
															onChange={() => {
																this.updateText(index);
															}}
															maxLength={field.maxLength}
															class="input-field"
															placeholder={field.placeholder}
															value={field.text}
															style={{
																top: `${field.location.y}`,
																left: `${field.location.x}`,
																width: `${field.location.width}`,
																height: `${field.location.height}`,
																fontSize: field.style.fontSize,
																fontFamily: field.style.fontFamily,
																overflow: 'hidden',
																maxHeight: `${field.location.width}`,
																padding: 0,
															}}
														/>
													);
												})}
												<div class="button-bar">
													<button
														class="meme-action-btn offset-btn left-btn btn"
														onClick={() => {
															this.moveUserImage('left');
														}}
													>
														<i class="fa fa-angle-double-left" aria-hidden="true" />
													</button>

													<button
														class="meme-action-btn offset-btn right-btn btn"
														onClick={() => {
															this.moveUserImage('right');
														}}
													>
														<i class="fa fa-angle-double-right" aria-hidden="true" />
													</button>
													<button
														class="meme-action-btn remove-btn btn"
														onClick={() => {
															this.clearFileInput();
														}}
													>
														<i class="fa fa-trash-o" aria-hidden="true" />
													</button>
													<button
														class="meme-action-btn rotate-btn btn"
														onClick={() => {
															this.rotateUserImage();
														}}
													>
														<i class="fa fa-repeat" aria-hidden="true" />
													</button>
													<div
														class={
															'share-btns' +
															(meme.fields.reduce((result, field) => {
																return result || field.text.length > 3;
															}, false)
																? ' active'
																: '')
														}
													>
														<button
															ref="facebookBtn"
															class="meme-action-btn facebook-btn btn"
															onClick={event => {
																this.socialClick(event);
															}}
															style={{ visibility: 'hidden' }}
														>
															<i class="fa fa-facebook" aria-hidden="true" />
														</button>
														<a
															ref="downloadBtn"
															class="meme-action-btn download-btn btn"
															download="birmingham-meme.png"
															target="_blank"
															onClick={() => {
																this.refs.downloadBtn.href = this.refs.memeCanvas.getCanvasImage();
															}}
														>
															<i class="fa fa-download" aria-hidden="true" />
														</a>
														<button
															ref="twitterBtn"
															class="meme-action-btn twitter-btn btn"
															onClick={event => {
																this.socialClick(event);
															}}
															style={{ visibility: 'hidden' }}
														>
															<i class="fa fa-twitter" aria-hidden="true" />
														</button>
														<button
															ref="saveBtn"
															class="meme-action-btn save-btn btn"
															onClick={() => {
																this.saveMeme();
															}}
															style={{ display: meme.saved ? 'none' : 'block' }}
														>
															SAVE IMAGE
														</button>
													</div>
												</div>
											</div>
										)}
									</div>
								</MemeCanvas>
							) : (
								''
							)}
						</div>
					</div>
					<Footer />
					{async.inProgress ? <Preloader fixed={true} /> : ''}
				</div>
			</div>
		);
	}
}

export default Main;



// WEBPACK FOOTER //
// ./src/js/components/main.js